module.exports = __webpack_public_path__ + "static/media/kano2.4644e8f0.png";